module.exports = __webpack_public_path__ + "images/info_screen_f62ed1e48bd9fbf93005ce4b240c3518.png";